/**
 * Situação de um produto
 */
export enum ProductStoreStatus {
  SCHEDULED = 'SCHEDULED', // Programada
  PUBLISHED = 'PUBLISHED', // Publicada
  NOT_PUBLISHED = 'NOT_PUBLISHED', // Não publicada
  DRAFT = 'DRAFT', // Rascunho
  DELETED = 'DELETED', // Deletada
}

export const translateProductStoreStatus = (status: ProductStoreStatus): string => {
  switch (status) {
    case ProductStoreStatus.SCHEDULED:
      return 'Programado';
    case ProductStoreStatus.PUBLISHED:
      return 'Publicado';
    case ProductStoreStatus.NOT_PUBLISHED:
      return 'Não publicado';
    case ProductStoreStatus.DRAFT:
      return 'Rascunho';
    case ProductStoreStatus.DELETED:
      return 'Deletado';
    default:
      return status;
  }
};

export const colorByProductStatus: Record<ProductStoreStatus, string> = {
  [ProductStoreStatus.NOT_PUBLISHED]: 'red.500',
  [ProductStoreStatus.PUBLISHED]: 'green.500',
  [ProductStoreStatus.SCHEDULED]: 'blue.500',
  [ProductStoreStatus.DRAFT]: 'gray.500',
  [ProductStoreStatus.DELETED]: 'red.500',
};

export class ProductStore {
  source_url: string
  updated_at!: string;
  image_url!: string;
  created_at!: string;
  title!: string;
  published_at!: string;
  uuid!: string;
  status!: ProductStoreStatus;
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  partner_name?: string;
  partner_uuid?: string;
  price: number;
}
